import {
  faNodeJs,
  faJs,
  faCss3Alt,
  faJava,
  faLinux,
} from '@fortawesome/fontawesome-free-brands';
import { faCodeBranch, faDatabase } from '@fortawesome/fontawesome-free-solid';

export const skills = [
  {
    icon: faNodeJs,
    name: 'Node.js',
    description: 'Server side JavaScript',
    percentage: 100,
  },
  {
    icon: faJs,
    name: 'Client side JavaScript',
    description: 'SPA (Angular, React.js, Vue.js), JQuery, etc.',
    percentage: 100,
  },
  {
    icon: faCodeBranch,
    name: 'VCS',
    description: 'Git, Mercurial',
    percentage: 100,
  },
  {
    icon: faDatabase,
    name: 'Databases',
    description: 'MongoDB, PostgreSQL, ElasticSearch, redis, etc.',
    percentage: 100,
  },
  {
    icon: faCss3Alt,
    name: 'CSS',
    description: 'CSS, Less, Sass',
    percentage: 80,
  },
  {
    icon: faJava,
    name: 'Scala, Java',
    description: 'Server side usage',
    percentage: 80,
  },
  {
    icon: faLinux,
    name: 'Linux administration',
    description: 'Server setup, Docker, Nginx, etc.',
    percentage: 70,
  },
];
